<template>
    <div class="tableStyle">
        <div class="buttonStyle">
            <el-button plain icon="el-icon-circle-check" type="success" @click="submitForm('ruleForm')">{{ "保存"
                }}</el-button>
            <el-button plain icon="el-icon-refresh" type="primary" @click="resetForm('ruleForm')">{{ "重置" }}</el-button>
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="名称" prop="name">
                <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>
            <el-form-item label="起始数字" prop="beginNumber">
                <el-input v-model="ruleForm.beginNumber" disabled></el-input>
            </el-form-item>
            <el-form-item label="数字长度" prop="numberLength">
                <el-input v-model="ruleForm.numberLength"></el-input>
            </el-form-item>
            <el-form-item label="描述" prop="description">
                <el-input type="textarea" v-model="ruleForm.description"></el-input>
            </el-form-item>
            <el-form-item label="是否启用" prop="enabled">
                <el-select v-model="ruleForm.enabled" placeholder="请选择自动编号状态">
                    <el-option label="是" value='1'></el-option>
                    <el-option label="否" value='0'></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="前缀" prop="pre">
                <el-input v-model="ruleForm.pre"></el-input>
            </el-form-item>
            <el-form-item label="后缀" prop="suf">
                <el-input v-model="ruleForm.suf"></el-input>
            </el-form-item>
            <el-form-item label="下一个编号" prop="nextAutoNumber">
                <el-input v-model="ruleForm.nextAutoNumber" disabled></el-input>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import axios from "axios";
export default {
    data() {
        return {
            ruleForm: {
                name: '',
                beginNumber: '',
                numberLength: '',
                description: '',
                enabled: '',
                pre: '',
                suf: '',
                nextAutoNumber: ''
            },
            rules: {
                name: [
                    { required: true, message: '请输入自动编号名称', trigger: 'blur' }
                ],
                beginNumber: [
                    { required: true, message: '请输入起始数字', trigger: 'blur' }
                ],
                numberLength: [
                    { required: true, message: '请输入数字长度', trigger: 'blur' }
                ]
            },
            autoNumber_edit_old: '',
            autoNumber_edit: ''
        }
    },
    methods: {
        loadNumberData() {
            const { id } = this.$route.query;
            if (!id) {
                return
            }
            axios.get('/pmdm/admin/autonumber/getAutoNumber?id=' + this.$store.state.objectId.id).then(res => {
                console.log(res);
                if (res.data.code == 200) {
                    let data = res.data.object.autoNumber;
                    this.autoNumber_edit_old = data;
                    this.ruleForm.name = data.name;
                    this.ruleForm.beginNumber = data.beginNumber;
                    this.ruleForm.numberLength = data.numberLength;
                    this.ruleForm.description = data.description;
                    this.ruleForm.enabled = data.enabled === 1 ? '是' : '否';
                    this.ruleForm.pre = data.pre;
                    this.ruleForm.suf = data.suf;
                    this.ruleForm.nextAutoNumber = data.nextAutoNumber;
                };
            }).catch(function (error) { });
        },
        submitForm(formName) {
            console.log(this.ruleForm);
            console.log(this.autoNumber_edit_old);


            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.autoNumber_edit = this.ruleForm;
                    var obj = this.contrastData(this.autoNumber_edit_old, this.autoNumber_edit);
                    console.log(obj);
                    if (obj.enabled && obj.enabled === '是') {
                        obj.enabled = 1;
                    } else if (obj.enabled && obj.enabled === '否') {
                        obj.enabled = 0;
                    }
                    if (JSON.stringify(obj) == "{}") {
                        return false;
                    };
                    obj.id = this.autoNumber_edit_old.id;
                    if (JSON.stringify(obj) !== '{}') {
                        this.$refs[formName].validate((valid) => {
                            if (valid) {
                                if (this.autoNumber_edit.numberLength > 9) {
                                    this.$message.error(this.$t('message.error.autoNumLengthLessTen'));
                                    return false
                                };
                                axios.post('/pmdm/admin/autonumber/update', obj).then((res) => {
                                    if (res.data.code == 200) {
                                        this.$message({
                                            showClose: true,
                                            message: res.data.message,
                                            type: 'success'
                                        });
                                        this.pageListDataShow = false;
                                        this.$emit("update");
                                    }
                                    this.loadNumberData();
                                }).catch(function (error) {
                                    console.log(error);
                                });
                            } else {
                                return false;
                            }
                        });
                    } else {
                        this.$message.error(this.$t('message.error.change'));
                    }
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        }
    },
    created() {
        this.loadNumberData();
    },
}
</script>
<style scoped>
.tableStyle {
    margin: 2% 3%;

}

::v-deep.el-table th {
    text-align: center;
}

::v-deep.el-table td {
    text-align: center;
}

.buttonStyle {
    margin: 1% 0;
}

.flex-container {
    display: flex;
    align-items: center;
}

.divider {
    flex-grow: 1;
    height: 1px;
    background-color: #000000;
    margin: 0 5px;
}
</style>